import React, {useState} from 'react';
import {Portlet, PortletBody, PortletHeader, PortletHeaderToolbar} from "../../../components/Portlet";
import PortletHeaderSearch from "../../base/components/forms/portlerHeaderSearch";
import {Link} from "react-router-dom";
import {AirBookingCreateRoute, AirBookingEditRoute, RailCreateRoute, RailEditRoute} from "../../routesConstants";
import DataTable from "../../../components/dataTable";
import moment from "moment/moment";
import {Helmet} from "react-helmet";
import ListForm from "../components/ListForm";
import numberFormat from "../../../helpers/numberFormat";

const RailwaysList = () => {
  const [query, setQuery] = useState({
    orderNumber:'',
    ticketNumber:'',
    pax:'',
    buyer:'',
    departure:'',
    arrival:'',
    forPaiments: false
  });
  const columns = [
    {
      Header: 'Код бронирования',
      accessor: 'orderNumber',
      Cell: ({value, row}) => <Link to={RailEditRoute + row.original.id } >{value}</Link>
    },
    {
      Header: 'Дата выписки',
      accessor: 'issueDate',
    },
    {
      Header: 'Cоздал',
      accessor: 'issuedBy',
    },
    {
      Header: 'Покупатель',
      accessor: 'buyer',
    },
    {
      Header: "Действия",
      Cell: ({value, row}) => (<Link className={"btn btn-sm btn-clean btn-icon btn-icon-md"} to={RailEditRoute + row.original.id}><i className={"la la-edit"}/></Link>)
    }
  ]
  const renderArray = (array) =>{
    return array.map((v,i)=>{
      return <React.Fragment key={i}>
        {v}{i+1 !== array.length && <br/>}
      </React.Fragment>
    })
  }
  const columsForPaiments = [
    {
      Header: 'Дата выписки',
      accessor: 'issueDate',
      Cell: ({value, row}) => <Link to={RailEditRoute + row.original.id } target={'_blank'}>{value}</Link>
    },
    {
      Header: 'Пассажир',
      accessor: 'paxes',
      Cell: ({value, row}) => <>{renderArray(value)}</>
    },
    {
      Header: 'Маршрут',
      accessor: 'route',
      Cell: ({value, row}) => <>{renderArray(value)}</>
    },
    columns[3],
    {
      Header: '№ Билета',
      accessor: 'tickets',
      Cell: ({value, row}) => <>{renderArray(value)}</>
    },
    {
      Header: 'Закуп',
      accessor: 'zacup',
      Cell: ({value, row}) => <>{value.map((v,i)=>{
        return <React.Fragment key={i}>
          {numberFormat(v)}{i+1 !== value.length && <br/>}
        </React.Fragment>
      })}</>
    },
  ]
  return (
    <>
      <Helmet>
        <title>ЖД</title>
      </Helmet>
      <ListForm query={query} setQuery={setQuery}/>
      <Portlet>
        <PortletHeader
          title={"Список ЖД бронирований"}
          toolbar={
            <PortletHeaderToolbar>
                <Link to={RailCreateRoute} className="btn btn-sm btn-primary">
                  <i className="la la-plus"/>
                  Добавить
                </Link>
            </PortletHeaderToolbar>
          }
        />
        <PortletBody>
          <DataTable columns={query?.forPaiments ? columsForPaiments : columns}
                     search={query}
                     itemsPerPage={query?.forPaiments ? 20: 10}
                     url={`/api/railways/`}/>
        </PortletBody>
      </Portlet>

    </>
  );
};

export default RailwaysList;
